/**
 * @generated SignedSource<<98186ecf5da987723677042123e68f4b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AutoRecordRulesListItemDuplicateAutoRecordRuleMutation$variables = {
  id: string;
};
export type AutoRecordRulesListItemDuplicateAutoRecordRuleMutation$data = {
  readonly duplicateAutoRecordRule: {
    readonly success: boolean;
  } | null;
};
export type AutoRecordRulesListItemDuplicateAutoRecordRuleMutation = {
  response: AutoRecordRulesListItemDuplicateAutoRecordRuleMutation$data;
  variables: AutoRecordRulesListItemDuplicateAutoRecordRuleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "DuplicateAutoRecordRulePayload",
    "kind": "LinkedField",
    "name": "duplicateAutoRecordRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AutoRecordRulesListItemDuplicateAutoRecordRuleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AutoRecordRulesListItemDuplicateAutoRecordRuleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d979ad4fb93173b0d83b8b08281b986b",
    "id": null,
    "metadata": {},
    "name": "AutoRecordRulesListItemDuplicateAutoRecordRuleMutation",
    "operationKind": "mutation",
    "text": "mutation AutoRecordRulesListItemDuplicateAutoRecordRuleMutation(\n  $id: ID!\n) {\n  duplicateAutoRecordRule(input: {id: $id}) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "557560fc98dee1d6b2dade391e4f11ae";

export default node;
